import React, { useState } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import { TextField, DropdownField } from 'components/forms';
import { makeOwner } from 'lib/factories';
import { H1, H2, P } from 'components/text';

const Owners = () => {
  const { values } = useFormikContext();
  const [ownersNum, setOwnersNum] = useState(0); // eslint-disable-line no-unused-vars
  const beneficial_owners = values.entity && values.entity.beneficial_owners;

  // increase or decrease the number of owners to match the selected number
  const handleNumChange = (n) => {
    if (n > beneficial_owners.length) {
      for (let i = beneficial_owners.length; i < n; i++) {
        beneficial_owners.push(makeOwner());
      }
    }

    if (n < beneficial_owners.length) {
      for (let i = beneficial_owners.length; i > n; i--) {
        beneficial_owners.pop();
      }
    }

    // trigger re-render
    setOwnersNum(n);
  };

  return (
    <>
      <H1>Beneficial Owners</H1>
      <P>
        A beneficial owner is any individual on a pass through basis that owns
        20% or more of the participating entity.
      </P>
      <P>Each owner will be emailed a unique link to verify their identity.</P>

      <DropdownField
        name="ownersNum"
        label="How many beneficial owners are there?"
        required
        onChange={(e) => handleNumChange(Number(e.value))}
        options={[
          { value: 0, label: '0' },
          { value: 1, label: '1' },
          { value: 2, label: '2' },
          { value: 3, label: '3' },
          { value: 4, label: '4' },
          { value: 5, label: '5' },
        ]}
        defaultValue={{ value: 0, label: '0' }}
      />

      <hr />

      <FieldArray
        name="beneficial_owners"
        render={() => (
          <>
            {beneficial_owners &&
              beneficial_owners.map((el, index) => {
                const owner = `entity.beneficial_owners[${index}]`;

                return (
                  <div key={index}>
                    <H2>Beneficial Owner {index + 1}</H2>

                    <TextField
                      name={`${owner}.percentage_ownership`}
                      label="Percentage of ownership"
                      type="number"
                      min="20"
                      max="100"
                      required
                    />

                    <TextField
                      name={`${owner}.email`}
                      label="Email"
                      type="email"
                      required
                    />

                    <hr />
                  </div>
                );
              })}
          </>
        )}
      />
    </>
  );
};

export default Owners;
